// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl, getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import LinksState from "@insite/client-framework/Store/Links/LinksState";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Breadcrumbs, { BreadcrumbsPresentationProps } from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@insite/mobius/Link";
import React from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import BreadcrumbStructuredData from "@store/Library/Components/Toolkit/StructuredData/BreadcrumbStructuredData";
/* Starter Custom Code - End */

// Foundation --->
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
// <--- Foundation

interface OwnProps {
    extendedStyles?: PageBreadcrumbsStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        links: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl: getHomePageUrl(state),
    };
};

export interface PageBreadcrumbsStyles {
    breadcrumbs?: BreadcrumbsPresentationProps;
    // Foundation
    wrapper?: InjectableCss;
}

export const pageBreadcrumbStyles: PageBreadcrumbsStyles = {
    /* Foundation Custom Code - Start */
    wrapper: {
        css: css`
            background-color: ${getColor("common.accentLighter")};
        `,
    },
    /* Foundation Custom Code - End */
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageBreadcrumbs = (props: Props) => {
    // Foundation Custom Code
    let links = props.links || generateLinksFrom(props.linksState, props.nodeId, props.homePageUrl);

    const styles = useMergeStyles("pageBreadcrumbs", pageBreadcrumbStyles, props.extendedStyles);

    // Foundation --->
    links = [
        {
            ...links[0],
            children: translate("Home"),
        },
        ...links.slice(1),
    ];
    // <--- Foundation

    /* Starter Custom Code - Start */
    return (
        // Foundation - Styled Wrapper --->
        <StyledWrapper {...styles.wrapper}>
            <Breadcrumbs links={links} data-test-selector="pageBreadcrumbs" {...styles.breadcrumbs} />
            <BreadcrumbStructuredData links={links} />
        </StyledWrapper>
        // <--- Foundation
    );
    /* Starter Custom Code - End */
};

export function generateLinksFrom(linksState: LinksState, nodeId: string, homePageUrl: string) {
    const links: LinkProps[] = [];
    let currentLink = getPageLinkByNodeId({ links: linksState }, nodeId);
    const vmiPageTypes: string[] = [
        "VmiDashboardPage",
        "VmiLocationsPage",
        "VmiLocationDetailsPage",
        "VmiBinsPage",
        "VmiBinDetailsPage",
        "VmiReportingPage",
        "VmiUsersPage",
        "VmiOrderHistoryPage",
        "VmiOrderDetailsPage",
    ];
    const vmiExcludePageTypes: string[] = ["MyAccountPage"]; // Starter Removed - HomePage
    const search = (targetText: string) => (sourceTextArray: string) => sourceTextArray === targetText;
    const isVmiPageType = !currentLink?.type ? false : vmiPageTypes.some(search(currentLink.type));

    while (currentLink) {
        const isVmiExcludePageType = !currentLink?.type ? false : vmiExcludePageTypes.some(search(currentLink.type));
        if (!isVmiPageType || !isVmiExcludePageType) {
            links.unshift({
                children: currentLink.type === "HomePage" ? translate("Home_Breadcrumb") : currentLink.title,
                href: currentLink.url,
                type: currentLink.type,
            });
        }

        currentLink = currentLink.parentId
            ? getPageLinkByNodeId({ links: linksState }, currentLink.parentId)
            : undefined;
    }

    return links;
}

export default connect(mapStateToProps)(PageBreadcrumbs);
